import clsx from "clsx";
import { useEffect, useRef, useState } from "react";
import { CTAButton, type CTAButtonProps } from "../CTAButton";

interface StickyCtaBarProps {
  text: string;
  href: string;
  variant?: CTAButtonProps["variant"];
}

export function StickyCtaBar({ text, href, variant = "accent" }: StickyCtaBarProps) {
  const [visible, setVisible] = useState(false);
  const observerRef = useRef<IntersectionObserver | null>(null);

  useEffect(() => {
    if (typeof IntersectionObserver === "undefined") return;
    const heroCta = document.querySelector("[data-hero-cta]");
    if (!heroCta) return;

    observerRef.current = new IntersectionObserver(([entry]) => {
      setVisible(!entry.isIntersecting);
    });

    observerRef.current.observe(heroCta);

    return () => {
      observerRef.current?.disconnect();
    };
  }, []);

  return (
    <div
      className={clsx(
        "sticky-cta-bar",
        "flex items-center justify-center gap-4",
        "bg-brand text-brand-content shadow-lg",
        visible && "is-visible",
      )}
      data-component="StickyCtaBar"
    >
      <CTAButton text={text} href={href} variant={variant} size="md" goalName="sticky_cta" />
    </div>
  );
}

StickyCtaBar.displayName = "StickyCtaBar";
